<div class="ada-row">
	<p class="sim-link" (click)="setModal($event, true)">ADA Information</p>
</div>

<div *ngIf="show" class="modal-background" (click)="setModal($event, false)">
	<div class="modal-container">
		<p>King Trivia will provide appropriate services, whenever necessary to ensure effective communication with members of the public who have hearing, sight, or speech impairments, unless to do so would result in fundamental alteration of its programs or undue adminstrative or financial burden. A person requiring an accomodation or an auxiliary aid or service to participate in a King Trivia event should <strong>call 818-808-0008 ext 8</strong> as far in advance as possible but no later than <strong>72 hours before the scheduled event.</strong></p>
	</div>
</div>
